import { createSelector } from 'reselect'

export const selectUser = state => state.user

export const selectSuperUserData = createSelector([selectUser], user => {
  const userInfo = user?.userRole
  if (!userInfo) return false
  return userInfo === 'superuser'
})

export const selectUserData = createSelector([selectUser], user => {
  const userInfo = user?.userRole
  if (!userInfo) return false
  return userInfo === 'user'
})

export const selectManagerdata = createSelector([selectUser], user => {
  const userInfo = user?.userRole
  if (!userInfo) return false
  return userInfo === 'manager'
})
